import { GridRowClassNameParams } from '@mui/x-data-grid';
import { ClientRetentionEntry } from '../../../api/clientsApi/interfaces';
import { ContactRetentionEntry } from '../../../api/contactsApi/interfaces';

export const getRowClassName = (
  params: GridRowClassNameParams<ClientRetentionEntry | ContactRetentionEntry>
): string => {
  const daysLeft = params.row.daysLeft || 100;

  if (daysLeft < 0) {
    return 'row-overdue';
  } else if (daysLeft <= 7) {
    return 'row-danger';
  } else if (daysLeft <= 30) {
    return 'row-warning';
  }

  return '';
};
